import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../../../../Interfaces/filter";
import personaServicio from "../../../../../services/persona/personaServicio";
import { IComboPersona } from "../../../../../Interfaces/IPersona";
import { EstadoEquipoService } from "../../../../../services/auxiliar/estadoEquipoService";

const UseComboEstadoEquipo = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboEstadoEquipo, setDataComboEstadoEquipo] = useState<IComboBoxOption[]>([]);
    const comboBoxRefEstadoEquipo = useRef<IComboBox>(null);
    const onClickComboEstadoEquipo = () => comboBoxRefEstadoEquipo.current?.focus(true);
    const _openOption = useCallback(() => comboBoxRefEstadoEquipo.current?.focus(true), []);
    const [filterEstado, setfilterEstado] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const _onkeyUpSearchEstadoEquipo = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefEstadoEquipo.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        EstadoEquipoService.ListarEstado(filterEstado).then((res) => {
            if (res.status === 200) {
                setDataComboEstadoEquipo(res.data);
            }
        });
    };
    

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    return {
        dataComboEstadoEquipo,
        onClickComboEstadoEquipo,
        _onkeyUpSearchEstadoEquipo,
        comboBoxRefEstadoEquipo,
        setFilter,
        filter
    };
}

export { UseComboEstadoEquipo }
